var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInoxPvRwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 38,
    viewBox: "0 0 160 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93615 4.51758H0V33.6667H4.0765V22.4394H7.93615C12.8878 22.4394 16.8971 18.4302 16.8971 13.4785C16.8971 8.52681 12.8878 4.51758 7.93615 4.51758ZM7.93615 18.3629H4.0765V8.59411H7.93615C10.6364 8.59411 12.8205 10.7783 12.8205 13.4785C12.8205 16.1787 10.6364 18.3629 7.93615 18.3629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2821 33.6742H55.346L48.0157 22.043C51.6734 20.9135 54.3287 17.5102 54.3287 13.4785C54.3287 8.52681 50.3195 4.51758 45.3678 4.51758H37.4316V33.6667H41.5082V22.4394H43.2061L50.2896 33.6667L50.2821 33.6742ZM41.5007 8.59413H45.3603C48.0605 8.59413 50.2447 10.7783 50.2447 13.4785C50.2447 16.1787 48.0605 18.3629 45.3603 18.3629H41.5007V8.59413Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7715 3.6427L26.0218 21.5196L21.2795 3.6427L16.0287 0L26.0218 37.5565L36.0224 0L30.7715 3.6427Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3348 14.0859L66.5017 17.6763H70.279L67.2273 19.8978L68.3941 23.4881L65.3348 21.2666L62.283 23.4881L63.4499 19.8978L60.3906 17.6763H64.168L65.3348 14.0859Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6483 7.33203H75.3254V30.2953H82.6483V7.33203Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.725 30.2953V7.33203H93.5392L101.236 19.629V7.33203H108.252V30.2953H101.281L93.7561 18.2976V30.2953H86.725Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.725 30.2953H136.37L144.276 18.3649L137.171 7.33203H145.369L148.48 13.1888L151.726 7.33203H159.924L152.415 18.3649L159.999 30.2953H151.756L148.293 23.9224L144.725 30.2953Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.075 5.84375C116.909 5.84375 111.097 11.6556 111.097 18.8214C111.097 25.9871 116.909 31.799 124.075 31.799C131.24 31.799 137.052 25.9871 137.052 18.8214C137.052 11.6556 131.24 5.84375 124.075 5.84375ZM124.075 24.4687C120.955 24.4687 118.427 21.9405 118.427 18.8214C118.427 15.7023 120.955 13.1815 124.075 13.1815C127.194 13.1815 129.722 15.7097 129.722 18.8214C129.722 21.933 127.194 24.4687 124.075 24.4687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInoxPvRwhite);
export default __webpack_public_path__ + "static/media/inoxPVRwhite.9c6b4f7e042ea90fa42c2d22755beace.svg";
export { ForwardRef as ReactComponent };